import { render } from "./AgentActionAssignmentPriority.vue?vue&type=template&id=2476ed09&scoped=true&ts=true"
import script from "./AgentActionAssignmentPriority.vue?vue&type=script&lang=ts"
export * from "./AgentActionAssignmentPriority.vue?vue&type=script&lang=ts"

import "./AgentActionAssignmentPriority.vue?vue&type=style&index=0&id=2476ed09&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2476ed09"]])

export default __exports__